import * as React from 'react'
import { cn } from '@/lib/utils'

interface DualProgressProps extends React.HTMLAttributes<HTMLDivElement> {
  qualificationValue: number
  transferredValue: number
  totalValue: number
  className?: string
}

const DualProgress = React.forwardRef<HTMLDivElement, DualProgressProps>(
  ({ className, qualificationValue, transferredValue, totalValue, ...props }, ref) => {
    const qualificationPercentage = totalValue > 0 ? (qualificationValue / totalValue) * 100 : 0
    const transferredPercentage = totalValue > 0 ? (transferredValue / totalValue) * 100 : 0

    return (
      <div
        ref={ref}
        className={cn('relative h-2 w-full overflow-hidden rounded-full bg-secondary', className)}
        {...props}
      >
        <div
          className="h-full bg-blue-500 transition-all"
          style={{
            width: `${qualificationPercentage}%`,
          }}
        />
        <div
          className="h-full bg-green-500 transition-all absolute top-0"
          style={{
            width: `${transferredPercentage}%`,
            left: `${qualificationPercentage}%`,
          }}
        />
      </div>
    )
  }
)
DualProgress.displayName = 'DualProgress'

export { DualProgress }
